import { useState } from 'react';
import { contractsApi } from '../lib/api';
import { toast } from 'sonner';
import { CustomerSection } from './contract-base/CustomerSection';
import { ImmobileSection } from './contract-base/ImmobileSection';
import { ImpiantoSection } from './contract-base/ImpiantoSection';
import { EditDialog } from './contract-base/EditDialog';

export default function ContractBaseData({ contract, onUpdate }) {
    const [editDialog, setEditDialog] = useState({ open: false, section: null, title: '', data: null });

    const handleEditCustomer = () => {
        toast.info('Per modificare i dati del cliente, vai alla sezione Clienti');
    };

    const handleEditImmobile = () => {
        setEditDialog({
            open: true,
            section: 'immobile',
            title: 'Modifica Dati Immobile',
            data: contract?.immobile || {}
        });
    };

    const handleEditImpianto = () => {
        setEditDialog({
            open: true,
            section: 'impianto',
            title: 'Modifica Dati Impianto',
            data: contract?.impianto || {}
        });
    };

    const handleSave = async (data) => {
        try {
            await contractsApi.updateBaseData(contract.id, { [editDialog.section]: data });
            toast.success('Dati salvati con successo');
            if (onUpdate) {
                onUpdate();
            }
        } catch (error) {
            console.error('Errore salvataggio dati base:', error);
            toast.error('Errore durante il salvataggio');
            throw error;
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold">Dati Base del Contratto</h2>
                <p className="text-sm text-muted-foreground">
                    Informazioni fondamentali del cliente, immobile e impianto
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <CustomerSection 
                    customer={contract?.customer} 
                    onEdit={handleEditCustomer} 
                />
                <ImmobileSection 
                    immobile={contract?.immobile} 
                    onEdit={handleEditImmobile} 
                />
                <ImpiantoSection 
                    impianto={contract?.impianto} 
                    onEdit={handleEditImpianto} 
                />
            </div>

            <EditDialog
                open={editDialog.open}
                onClose={() => setEditDialog({ open: false, section: null, title: '', data: null })}
                title={editDialog.title}
                section={editDialog.section}
                data={editDialog.data}
                onSave={handleSave}
            />
        </div>
    );
}
